import styles from "./prize.module.css";
import LazyLoad from "react-lazyload";

const Prize = ({ resources }) => {
  return (
    <section className={styles.ctn}>
      <h1>Prize</h1>
      <div className={styles.imgBox}>
        <div className={`${styles.winnersThree} m3-active-desktop`}>
          <h2>3</h2>
          winners
        </div>
        <LazyLoad className={`${styles.imgBox} m3-active-desktop`}>
          <img src={`${resources}m3challenge-prize.png`} alt="" />
        </LazyLoad>

        <LazyLoad className={`${styles.imgBox} m3-active-mobile`}>
          <img src={`${resources}m3challenge-prize-mobile.png`} alt="" />
        </LazyLoad>

        <LazyLoad className={`${styles.imgBox} ${styles.masterBundleImg} m3-active-desktop`}>
          <img src={`${resources}m3challenge-masterbundle.png`} alt="" />
        </LazyLoad>

        <LazyLoad className={`${styles.imgBox} ${styles.masterBundleImg} m3-active-mobile`}>
          <img src={`${resources}m3challenge-masterbundle-mobile.png`} alt="" />
        </LazyLoad>
      </div>
    </section>
  );
};

export default Prize;
